import { jsx as _jsx } from "react/jsx-runtime";
import { StyledTippy } from "./styled";
import { FlexSpan } from "../Grid";
export const Tooltip = ({ wrapperHeight, children, placement, ...rest }) => (_jsx(StyledTippy, { placement: placement ?? "top", ...rest, children: _jsx(FlexSpan, { display: "inline-flex", height: wrapperHeight, children: children }) }));
